import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden", "kgInput", "lbsInput", "kgSection", "lbsSection", "kgBtn", "lbsBtn"]
  static values = { kg: Number }

  connect() {
    // Initialize from stored kg value
    if (this.kgValue > 0) {
      this.kgInputTarget.value = this.kgValue
      this.updateLbsFromKg(this.kgValue)
    }
    // Default to kg view
    this.showKg()
  }

  showKg() {
    this.kgSectionTarget.classList.remove("hidden")
    this.lbsSectionTarget.classList.add("hidden")
    this.kgBtnTarget.classList.add("bg-white", "shadow-sm", "text-slate-900")
    this.kgBtnTarget.classList.remove("text-slate-600")
    this.lbsBtnTarget.classList.remove("bg-white", "shadow-sm", "text-slate-900")
    this.lbsBtnTarget.classList.add("text-slate-600")
  }

  showLbs() {
    this.kgSectionTarget.classList.add("hidden")
    this.lbsSectionTarget.classList.remove("hidden")
    this.lbsBtnTarget.classList.add("bg-white", "shadow-sm", "text-slate-900")
    this.lbsBtnTarget.classList.remove("text-slate-600")
    this.kgBtnTarget.classList.remove("bg-white", "shadow-sm", "text-slate-900")
    this.kgBtnTarget.classList.add("text-slate-600")
  }

  updateFromKg() {
    const kg = parseFloat(this.kgInputTarget.value) || 0
    this.hiddenTarget.value = kg
    this.updateLbsFromKg(kg)
  }

  updateFromLbs() {
    const lbs = parseFloat(this.lbsInputTarget.value) || 0
    const kg = Math.round(lbs * 0.453592 * 10) / 10
    this.hiddenTarget.value = kg
    this.kgInputTarget.value = kg
  }

  updateLbsFromKg(kg) {
    const lbs = Math.round(kg * 2.20462 * 10) / 10
    this.lbsInputTarget.value = lbs || ""
  }
}
